$(document).on('turbo:load', function () {
  const toggle    = document.getElementById('chat-toggle');
  const panel     = document.getElementById('chat-panel');
  const closeBtn  = document.getElementById('chat-close');
  const chatForm  = document.getElementById('chat-form');
  const chatInput = document.getElementById('chat-input');
  const messages  = document.getElementById('chat-messages');

  if (!toggle || !panel) return;

  function openPanel() {
    panel.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => chatInput && chatInput.focus(), 300);
  }

  function closePanel() {
    panel.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
  }

  toggle.addEventListener('click', function () {
    panel.classList.contains('is-open') ? closePanel() : openPanel();
  });

  closeBtn.addEventListener('click', closePanel);

  document.addEventListener('click', function (e) {
    if (panel.classList.contains('is-open') &&
        !panel.contains(e.target) &&
        !toggle.contains(e.target)) {
      closePanel();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
  });

  if (!chatForm) return;

  chatForm.addEventListener('submit', async function (e) {
    e.preventDefault();
    const question = chatInput.value.trim();
    if (!question) return;

    chatInput.value = '';
    chatInput.disabled = true;
    chatForm.querySelector('.chat-widget__send-btn').disabled = true;

    appendMessage(question, 'user');
    const typingEl = appendTyping();

    try {
      const res = await fetch('/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ question }),
      });
      const data = await res.json();
      typingEl.remove();
      appendMessage(data.answer || data.error || 'Keine Antwort erhalten.', 'bot');
    } catch {
      typingEl.remove();
      appendMessage('Verbindungsfehler – bitte versuche es erneut.', 'bot');
    } finally {
      chatInput.disabled = false;
      chatForm.querySelector('.chat-widget__send-btn').disabled = false;
      chatInput.focus();
    }
  });

  const ROBOT_SVG = `<svg viewBox="0 0 500 410" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M386.363 22.731H113.636C88.5321 22.731 68.1814 43.0816 68.1814 68.1855V250.004C68.1814 275.108 88.5321 295.458 113.636 295.458H386.363C411.467 295.458 431.818 275.108 431.818 250.004V68.1855C431.818 43.0816 411.467 22.731 386.363 22.731Z" stroke="currentColor" stroke-width="45.4545" stroke-linecap="round" stroke-linejoin="round"/><path class="chat-eye-l" d="M204.546 113.636V159.091" stroke="currentColor" stroke-width="45.4545" stroke-linecap="round" stroke-linejoin="round"/><path class="chat-eye-r" d="M295.454 113.636V159.091" stroke="currentColor" stroke-width="45.4545" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.7263 386.371H477.272" stroke="currentColor" stroke-width="45.4545" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

  function appendMessage(text, type) {
    const div = document.createElement('div');
    div.className = `chat-msg chat-msg--${type}`;
    const safe = escapeHtml(text);
    div.innerHTML = type === 'bot'
      ? `<div class="chat-msg__bot-icon">${ROBOT_SVG}</div><div class="chat-msg__bubble">${safe}</div>`
      : `<div class="chat-msg__bubble">${safe}</div>`;
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
    return div;
  }

  function appendTyping() {
    const div = document.createElement('div');
    div.className = 'chat-msg chat-msg--bot chat-typing-indicator';
    div.innerHTML = `
      <div class="chat-msg__bot-icon">${ROBOT_SVG}</div>
      <div class="chat-typing-dots">
        <span></span><span></span><span></span>
      </div>`;
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
    return div;
  }

  function escapeHtml(text) {
    const d = document.createElement('div');
    d.textContent = text;
    return d.innerHTML;
  }
});
